package fr.frux.core.ads

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flowOf

/**
 * Plateforme sans publicité : web (ADR 0030 point 7), desktop, iOS jusqu'au jalon M4. Le contrôleur
 * lit [supported] et n'appelle jamais le reste, qui répond tout de même sans effet par prudence.
 */
object NoAdsPlatform : AdsPlatform {
    override val supported: Boolean = false

    override val foreground: Flow<Boolean> = flowOf(true)

    override suspend fun requestConsentInfo(): ConsentInfo =
        ConsentInfo(formRequired = false, canRequestAds = false, privacyOptionsRequired = false)

    override suspend fun showConsentForm(): Boolean = false

    override suspend fun showPrivacyOptions(): Boolean = false

    override suspend fun initialize() = Unit

    override suspend fun preloadInterstitial(): Boolean = false

    override fun showInterstitial(onClosed: () -> Unit): Boolean = false

    override suspend fun loadRewarded(): Boolean = false

    override suspend fun showRewarded(request: RewardedRequest): RewardedOutcome = RewardedOutcome.UNAVAILABLE
}
